export enum FlooriIcons {
    hero = 'hero',
    empty = '',
}
